import React from 'react';
import { useTranslation } from "react-i18next";
import { Listbox, ListboxItem } from "@nextui-org/react";
import Header from "../../reusable/Header";
import { ArrowForward } from "../../icons/ArrowForward";
import PoweredBy from "../../reusable/PoweredBy";

const GovernmentDatabaseSelect = ({ onSelect, goBack, country }) => {
    const { t } = useTranslation();
    const handleSelect = (selected) => {
        if (selected) {
            const selectedKey = selected.values().next().value;
            const database = country.databases.find(db => db.id === selectedKey);
            if (database) {
                onSelect(database);
            }
        }
    };

    return (
        <div className="flex h-full flex-col">
            {/* Fixed Header */}
            <div className="top-0 left-0">
                <Header goBack={goBack} />
                <div className="mb-5 text-center flex flex-col">
                    <div className="font-medium text-xl" style={{color: "var(--urtentic-sdk-title, #000000)"}}>{t("governmentDatabases.databaseSelect.heading")}</div>
                    <div className="flex flex-row justify-center">
                        <div className="flex flex-row p-1 gap-2 bg-white items-center">
                            <img
                                src={country?.countryFlag}
                                alt={country?.countryName}
                                className="w-6 h-4 object-cover rounded-sm"
                            />
                            <div className="desc">{country?.countryName}</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Scrollable Listbox Section */}
            <div className="flex flex-col p-4 justify-between flex-grow overflow-auto">
                <div className="px-1 py-2 rounded-small">
                    {country?.databases?.length === 0 ? (
                        <div className="desc text-center">{t("governmentDatabases.databaseSelect.noDatabases")}</div>
                    ) : (
                        <Listbox
                            aria-label="Select database"
                            variant="flat"
                            disallowEmptySelection
                            selectionMode="single"
                            onSelectionChange={handleSelect}
                        >
                            {country?.databases?.map((database) => (
                                <ListboxItem
                                    className="p-4"
                                    key={database.id}
                                    showDivider
                                    description={<span style={{color: "var(--urtentic-sdk-body, #737373)"}}>{database.description}</span>}
                                    endContent={<ArrowForward />}
                                >
                                    <span style={{color: "var(--urtentic-sdk-body, #737373)"}}>{database.name}</span>
                                </ListboxItem>
                            ))}
                        </Listbox>
                    )}
                </div>
            </div>

            {/* Fixed PoweredBy Section */}
            <div className="flex justify-center p-2">
                <PoweredBy />
            </div>
        </div>
    );
};

export default GovernmentDatabaseSelect;
